<script>
import { mapState } from "vuex";

export default {
  name: "Snackbar",
  computed: {
    ...mapState({
      alert: (state) => state.alert.alert,
    }),
  },
};
</script>

<template>
  <v-snackbar v-model="alert.show" :color="alert.color" top>
    <div class="d-flex align-center">
      <div class="flex-grow-1">
        {{ alert.message }}
      </div>
      <v-icon small dark @click="alert.show = false" class="ml-2"> close </v-icon>
    </div>
  </v-snackbar>
</template>

<style scoped>

</style>